<template>
	<div class="mb-4 d-inline-block w-100">
		<img class="logo-boleto-flash" v-if="boleto_flash == '1'" src="~@/assets/img/pb_boleto_flash_mobile.svg">
		<img class="logo-pagbrasil mt-2" v-if="boleto_flash != '1'" src="~@/assets/img/logo_pagbrasil.svg">
		<a id="bt-print-gray" href="javascript:window.print();" class="bt-print-gray py-2 noprint">
			<img src="~@/assets/img/print.svg">
			<label for="bt-print-gray" class="ml-2">Imprimir</label>
		</a>
	</div>
</template>

<script>

export default {
	name: 'CabecalhoFlashImpressao',
	data(){
		return{}
	},

	components: {},

	mounted: function(){},

	computed: {
		boleto_flash(){
			return this.$store.state.boleto.boleto.flash;
		},
	}
}

</script>